<h2 mat-dialog-title>
  {{ getTitulo() }}
</h2>

<div class="alerta-toolbar">
  <input
    [(ngModel)]="busqueda"
    (input)="filtrarAlertas()"
    [placeholder]="getPlaceholder()"
    class="alerta-busqueda"
    autofocus
  />
  <span class="alerta-total">{{ alertasFiltradas.length }} alertas</span>
</div>

<mat-dialog-content *ngIf="tipo === 1" class="contenido-alerta">
  <div class="alerta-card" *ngFor="let noticia of alertasFiltradas">
    <div class="ac-titulo">
      <span class="ac-medicamento" [matTooltip]="noticia.medicamento">
        {{ noticia.medicamento }}
      </span>
    </div>
    <div class="ac-cod-fecha">
      <span class="ac-codigo">
        Codigo nacional: <b>{{ noticia.codigoNacional }}</b>
      </span>
      <span class="ac-fechas">
        Fecha inicio: {{ noticia.fechaInicio }}
        <span class="ac-fecha-barra">|</span>
        Fecha prevista fin: {{ noticia.ffin }}
      </span>
    </div>
    <div
      class="ac-obs"
      [ngClass]="{
        'ac-obs-amarilla': esObservacionAmarilla(noticia.observ),
        'ac-obs-roja': !esObservacionAmarilla(noticia.observ)
      }"
    >
      {{ noticia.observ }}
    </div>
  </div>
  <div *ngIf="alertasFiltradas.length === 0" class="alerta-vacio">
    No se encontraron alertas para el filtro ingresado.
  </div>
</mat-dialog-content>

<mat-dialog-content *ngIf="tipo === 2" class="contenido-alerta">
  <div class="ac2-card" *ngFor="let nota of alertasFiltradas" (click)="abrirHerramientaVidal(nota)">
    <div class="ac2-titulo">
      <span class="ac2-icono"></span>
      <span class="ac2-asunto" [matTooltip]="nota.asunto">{{ nota.asunto }}</span>
    </div>
    <div class="ac2-referencia">
      Nota informativa: <span class="ac2-referencia-bold">{{ nota.referencia }}</span>
    </div>
    <div class="ac2-fecha-link">
      <span>
        Publicado en {{ nota.fecha }}
      </span>
    </div>
  </div>
  <div *ngIf="alertasFiltradas.length === 0" class="alerta-vacio">
    No se encontraron notas para el filtro ingresado.
  </div>
</mat-dialog-content>

<mat-dialog-content *ngIf="tipo === 3" class="contenido-alerta">
  <div class="ac3-card" *ngFor="let noticia of alertasFiltradas" (click)="abrirHerramientaVidal(noticia)"
       style="cursor:pointer;">
    <img *ngIf="noticia.imagen" class="ac3-img" [src]="noticia.imagen" alt="Noticia" />
    <div class="ac3-main">
      <a
        class="ac3-titulo"
        rel="noopener"
        [matTooltip]="noticia.titulo"
      >{{ noticia.titulo }}</a>
      <div class="ac3-autor">
        {{ noticia.autor }}
      </div>
      <div class="ac3-breve">
        {{ noticia.breve }}
      </div>
      <div class="ac3-pubcat">
        <span class="ac3-categoria">{{ noticia.categoria }}</span>
        <span *ngIf="noticia.publicacion" class="ac3-publicacion">| {{ noticia.publicacion }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="alertasFiltradas.length === 0" class="alerta-vacio">
    No se encontraron noticias para el filtro ingresado.
  </div>
</mat-dialog-content>

<mat-dialog-content *ngIf="tipo === 4" class="contenido-alerta">
  <div class="ac4-card" *ngFor="let noticia of alertasFiltradas" (click)="abrirHerramientaVidal(noticia)"
       style="cursor:pointer;">
    <img
      *ngIf="noticia.imagen"
      class="ac4-img"
      [src]="noticia.imagen"
      alt="Alerta"
      width="64"
      height="48"
    />
    <div class="ac4-main">
      <a
        class="ac4-titulo"
        rel="noopener"
        [matTooltip]="noticia.titulo"
      >{{ noticia.titulo }}</a>
      <div class="ac4-autor">
        {{ noticia.autor }}
      </div>
      <div class="ac4-breve">
        {{ noticia.breve }}
      </div>
      <div class="ac4-pubcat">
        <span class="ac4-categoria">{{ noticia.categoria }}</span>
        <span *ngIf="noticia.publicacion" class="ac4-publicacion">| {{ noticia.publicacion }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="alertasFiltradas.length === 0" class="alerta-vacio">
    No se encontraron alertas para el filtro ingresado.
  </div>
</mat-dialog-content>

<mat-dialog-content *ngIf="tipo === 5" class="contenido-alerta">
  <div class="ac5-card" *ngFor="let noticia of alertasFiltradas" (click)="abrirHerramientaVidal(noticia)"
       style="cursor:pointer;">
    <div class="ac5-main">
      <a
        class="ac5-titulo"
        rel="noopener"
        [matTooltip]="noticia.titulo"
      >{{ noticia.titulo }}</a>
      <div class="ac5-autor">{{ noticia.autor }}</div>
      <div class="ac5-breve">{{ noticia.breve }}</div>
      <div class="ac5-pubcat">
        <span class="ac5-categoria">{{ noticia.categoria }}</span>
        <span *ngIf="noticia.publicacion" class="ac5-publicacion">| {{ noticia.publicacion }}</span>
      </div>
    </div>
  </div>
  <div *ngIf="alertasFiltradas.length === 0" class="alerta-vacio">
    No se encontraron monografias para el filtro ingresado.
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-stroked-button color="primary" (click)="close()">Cerrar</button>
</mat-dialog-actions>
